import * as Accordion from '@radix-ui/react-accordion'

import { useStepStore } from '@/stores/step-store/stepStore'

type BookingProps = {
	children: JSX.Element
}

export const BookingStepNavigation = ({ children }: BookingProps) => {
	const currentStep = useStepStore.use.currentStep()
	const setCurrentStep = useStepStore.use.setCurrentStep()

	return (
		<div>
			<Accordion.Root type="single" value={currentStep} onValueChange={setCurrentStep}>
				{children}
			</Accordion.Root>
		</div>
	)
}
